import { StyleSheet } from 'aphrodite';
import { error } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: 16,
		width: '100%',
	},
	inputContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 8,
	},
	addressFieldRow: {
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: 12,
		width: '100%',

		'@media (min-width: 722px)': {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},
	},
	addressField: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 8,
	},
	required: {
		color: error,
		fontWeight: 'bold',
	},
	countrySelectorContainer: {
		width: '100%',
	},
});
